export const Pad = {
  left: (num, count, padStr) => {
    const result = String("0" + num).slice(count * -1);
    return result;
  }
};


// WEBPACK FOOTER //
// ./src/util/Pad.js